import { CloseOutlined } from '@ant-design/icons';
import { type ReactNode, useState } from 'react';
import styled from 'styled-components';

import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';

import { CenterFlex, Flex, Space, VFlex } from '../base';

export type DefaultToastProps = {
  header: string | ReactNode;
  body?: string | ReactNode;
  Icon: ReactNode;
  actionIcon?: ReactNode;
  actionLabel?: string;
  onClick?: () => void;
};

const DefaultToast = (props: DefaultToastProps) => {
  const color = useColor();
  const { Icon } = props;
  const [closePressed, setClosePressed] = useState(false);
  if (closePressed) {
    return <></>;
  }
  return (
    <Style a="flex-start" g={16}>
      <Flex a="center" style={{ height: 20 }}>
        {Icon}
      </Flex>
      <VFlex g={4} f={1}>
        {props.header && typeof props.header === 'string' ? (
          <Typo type="body2" weight="sb" color={color.gray100}>
            {props.header}
          </Typo>
        ) : (
          props.header
        )}
        {props.body && typeof props.body === 'string' ? (
          <>
            <Space h="8px" />
            <Typo type="body3" weight="r" color={color.gray100}>
              {props.body}
            </Typo>
          </>
        ) : (
          props.body
        )}
      </VFlex>
      <Flex a="center" g={8}>
        {props.actionLabel && (
          <Flex g="8px" style={{ cursor: 'pointer' }}>
            <Typo
              type="body3"
              weight="sb"
              color={color.gray100}
              onClick={() => {
                props.onClick?.();
                setClosePressed(true);
              }}
              style={{ textDecoration: 'underline' }}
            >
              {props.actionLabel}
            </Typo>
          </Flex>
        )}
        <CenterFlex
          onClick={() => {
            setClosePressed(true);
          }}
          style={{
            width: 20,
            height: 20,
            cursor: 'pointer',
          }}
        >
          <CloseOutlined style={{ color: color.gray100 }} />
        </CenterFlex>
      </Flex>
    </Style>
  );
};

const Style = styled(Flex)`
  padding: 12px;
  position: relative;
  background: ${(props) => props.theme.colors.gray900};
  border-radius: 8px;
  width: 400px;
  box-shadow: 0px 1px 1px ${(props) => props.theme.colors.ND20};
`;
export default DefaultToast;
